<template>
  <div class="section-title">
    <h5>{{title}}</h5>
    <button v-if="isDesktop()" class="primary-btn" @click="goBack">
      <i class="fa fa-angle-left" />
      Back
    </button>
  </div>
</template>

<script>
import { goBack } from '@/utils/helpers'

export default {
  name: 'FormBreadCrumb',
  props: {
    title: String
  },
  methods: {
    goBack
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .section-title {
    @include custom-flex(space-between);
    margin-bottom: 15px;
    min-height: 30px;

    h5 {
      @include highlight-text();
    }

    button {
      i {
        margin-right: 5px;
      }
    }
  }
</style>
